export default "__VITE_ASSET__BGsuw7l3__"